export default __webpack_public_path__ + "static/media/retailandmerchant.a79a7d26.png";